import { FC } from 'react';
import { useParams } from 'react-router-dom';

const replaceParams = (path: string, params: Record<string, string | undefined>) =>
  path.replace(/:([a-zA-Z0-9_]+)/g, (_, key) => {
    if (params[key] === undefined) {
      return `:${key}`;
    }
    return params[key] || `:${key}`;
  });

interface ExternalNavigateProps {
  to: string;
}

export const ExternalNavigate: FC<ExternalNavigateProps> = ({ to }) => {
  const params = useParams();
  let url = to;
  if (Object.keys(params).length) {
    url = replaceParams(to, params);
  }
  window.location.replace(url);
  return null;
};
